import Base from './base';

import {
  LAZYLOAD_IMAGE_ATTRIBUTE,
  ORIGINAL_IMAGE_ATTRIBUTE,
  LAZYLOAD_CLASS_NAME,
  IMAGE_SELECTOR,
  DEFAULT_MOBILE_BREAKPOINT
} from '../../classnames/lazyload';

export default class Image extends Base {
  selector = IMAGE_SELECTOR;
  eventName = 'lazyloaded';
  screenWidth = window.innerWidth;
  pixelRatio = window.devicePixelRatio;
  maxPixelRatio = 1; // Max device pixel ratio. It limits the value of the pixelRatio variable
  pixelRatioCoefficient = 1; // Coefficient for calculating the optimal image size for mobile devices
  optimalMobileResolution =
    (this.screenWidth * (this.pixelRatio <= this.maxPixelRatio ? this.pixelRatio : this.maxPixelRatio)).toString();

  optimalSize = Math.floor(this.optimalMobileResolution * this.pixelRatioCoefficient);

  load = (element) => {
    const {
      originalImage, src, imageSize, imageQuality
    } = element.dataset;

    if (originalImage) {
      let imgSrc;

      const imageWidth = imageSize?.split('x')[0];
      const isOptimisationNeeded = this.screenWidth < DEFAULT_MOBILE_BREAKPOINT
        && (Number(imageWidth) > this.optimalSize || imageWidth === 'master')
        && imageQuality !== 'original';

      if (src && isOptimisationNeeded) {
        imgSrc = src.replace('small', `${this.optimalSize}x`);
      } else {
        imgSrc = originalImage;
      }

      element.setAttribute(LAZYLOAD_IMAGE_ATTRIBUTE, imgSrc);
      element.removeAttribute(ORIGINAL_IMAGE_ATTRIBUTE);
      element.classList.add(LAZYLOAD_CLASS_NAME);
    }
  };
}
